module.exports = __webpack_public_path__ + "static/img/card_04@2x.348e830.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card_04@2x.png
// module id = wQkD
// module chunks = 0